import React, { type ReactNode } from 'react';

import type { FeatureName } from 'constant/features';
import { useHasFeature } from 'hooks/useHasFeature';

interface FeatureGateProps {
    feature: FeatureName;
    children: ReactNode;
}

/** Renders children when the company entitlement is on; otherwise null. */
const FeatureGate: React.FC<FeatureGateProps> = ({ feature, children }) => {
    const allowed = useHasFeature(feature);
    if (!allowed) {
        return null;
    }
    return <>{children}</>;
};

export default FeatureGate;
